import setting from '@/setting.js'
import util from '@/utils/util'

export default {
  namespaced: true,
  state: {
    active: setting.pageTransition //是否开启页面过度动画
  },
  actions: {
    /**
     * 设置页面过渡动画开启状态
     */
    async set({ state }, active) {
      util.db.set('transition.active', state.active, true)
      state.active = active
    },

    /**
     * 读取页面过渡动画开启状态
     */
    async load({ state }) {
      state.active = util.db.get('transition.active', setting.pageTransition, true)
    }
  }
}
